import { render } from "./Select2Input.vue?vue&type=template&id=0384ac3e&scoped=true"
import script from "./Select2Input.vue?vue&type=script&lang=js"
export * from "./Select2Input.vue?vue&type=script&lang=js"

import "./Select2Input.vue?vue&type=style&index=0&id=0384ac3e&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0384ac3e"]])

export default __exports__